// Pure helpers for LandingPage.

export const DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const DEFAULT_SLOTS = [
  '08:00-09:00', '09:00-10:00', '10:00-11:00',
  '11:00-12:00', '12:00-13:00', '13:00-14:00', '14:00-15:00', '15:00-16:00',
  '16:00-17:00', '17:00-18:00', '18:00-19:00', '19:00-20:00', '20:00-21:00',
  '21:00-22:00', '22:00-23:00', '23:00-00:00',
];

export const getDayOfWeek = (dateStr) => {
  const dateObj = new Date(dateStr);
  return DAY_NAMES[dateObj.getDay()];
};

export const isSlotInBreak = (slotStart, breaks) => {
  if (!breaks || breaks.length === 0) return false;
  const slotHour = parseInt(slotStart.split(':')[0], 10);
  for (const b of breaks) {
    const s = parseInt(b.start.split(':')[0], 10);
    const e = parseInt(b.end.split(':')[0], 10);
    if (slotHour >= s && slotHour < e) return true;
  }
  return false;
};

export const getAvailabilityColor = (avail) => {
  if (!avail) return 'bg-gray-100 text-gray-400';
  const { available_courts, total_courts } = avail;
  const pct = (available_courts / total_courts) * 100;
  if (pct === 0) return 'bg-red-100 text-red-700 cursor-not-allowed';
  if (pct <= 40) return 'bg-orange-100 text-orange-700 hover:bg-orange-200';
  return 'bg-green-100 text-green-700 hover:bg-green-200';
};

export const getAvailabilityText = (avail) => {
  if (!avail) return 'Loading...';
  if (avail.available_courts === 0) return 'Fully Booked';
  if (avail.available_courts === avail.total_courts) return 'All Available';
  return `${avail.available_courts}/${avail.total_courts} Available`;
};
